export default "__VITE_ASSET__CSnbWB4l__"